import React from 'react';
import { Box, Select } from 'native-base';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from '~/shared/Icon';
import { Caption } from '~/shared/Typography';
import { useGeneralStyles, useMenuStyles } from '~/shared/styles';
import { AppRouteProps, useAppNavigate } from '~/pages';
import Pressable from '~/shared/Pressable';
import { useEffectOnce } from 'usehooks-ts';
import { I18nReacher, Member, useAppSettings, useI18n, useSpringBigStore } from '@springbig/shared';

type ProfileMenuRoutesProps = {
    title: I18nReacher;
    path?: AppRouteProps;
    url?: string;
}

const profileMenuRoutes: (wallet_id: string, member: Member) => ProfileMenuRoutesProps[] = (wallet_id: string, member: Member) => [
    {
        title: 'profileMenu.my_information',
        path: `w/${wallet_id}/profile/menu/account`,
    },
    {
        title: 'profileMenu.message_notifications',
        path: `w/${wallet_id}/profile/menu/settings`,
    },
    {
        title: 'profileMenu.terms_condition',
        url: member?.terms_and_conditions_link
    },
    {
        title: 'profileMenu.privacy_policy',
        url: member?.privacy_policy_url
    }
];

const ProfileMenuOptions = () => {

    const { navigate, params } = useAppNavigate();
    const { languages } = useAppSettings();
    const { setLanguage, languageLabel, setLanguageLabel } = useI18n();
    const { member } = useSpringBigStore();
    const gStyle = useGeneralStyles();

    const {
        icon,
        card_background,
        card_border,
    } = useMenuStyles();

    useEffectOnce(() => {

        if (languages && languages.length > 0) {

            const currentLang = languages.find(lang => lang.label === languageLabel);

            if (currentLang) {
                return;
            }

            languages.map(lang => {

                if (lang.default) {
                    setLanguageLabel(lang.label);
                    setLanguage(lang.label, lang.i18n);
                }
            });
        }
    });

    const handleLanguageChange = (lang: string) => {

        if (languageLabel === lang) {
            return;
        }

        if (!languages) {
            return;
        }

        const _lang = languages.find((l) => l.label === lang);

        if (_lang) {
            setLanguage(_lang.label, _lang.i18n);
        }

        setLanguageLabel(lang);
    };

    return (
        <Box mb={4}>
            {
                profileMenuRoutes(params.wallet_id, member).map((route: ProfileMenuRoutesProps, index: number) => (

                    (route.url || route.path) && <Box
                        bg={card_background}
                        borderColor={card_border}
                        borderWidth={1}
                        p={4}
                        mt={index === 0 ? 4 : 0}
                        key={`${route.title}-${route.url || route.path}-${index}`}
                    >
                        <Pressable
                            flexDirection={'row'}
                            justifyContent='space-between'
                            onPress={() => (route.url ? window.open(route.url, '_blank', 'noopener,noreferrer') : navigate(route.path))}
                        >
                            <Caption
                                color={gStyle.text}
                                text={route.title}
                                underline={route.url && true}
                            />
                            <SpIcon
                                color={icon}
                                icon={faAngleRight}
                            />
                        </Pressable>
                    </Box>
                ))
            }
            {
                languageLabel && languages && languages.length > 1 && (
                    <Box
                        p={4}
                        borderColor={card_border}
                        mb={2}
                    >
                        <Caption
                            text={'general.select_language'}
                        />
                        <Select
                            selectedValue={languageLabel}
                            minWidth={90}
                            onValueChange={(itemValue) => {

                                handleLanguageChange(itemValue);
                            }}
                        >
                            {
                                languages.map((lang, index) => (

                                    <Select.Item
                                        key={`${lang.label}-${index}`}
                                        label={lang.label}
                                        value={lang.label}
                                    />
                                ))
                            }
                        </Select>
                    </Box>

                )
            }
        </Box>
    );

};

export default ProfileMenuOptions;
